exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".spacer[data-v-79899939] {\n  min-height: 3rem;\n}\n#dropzone[data-v-79899939] {\n  background-color: #f4f4f4;\n}\n", ""]);

// exports
